import * as Handlebars from 'handlebars';
import BaseFeature from '../../foundation/base/base';
import { initBehaviors } from '../../foundation/featureLoader';

class QuestionnaireResult extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;
		this.endpoint = this.el.dataset.endpoint;
		this.portal = this.el.querySelector('[data-ref="questionnaireResult__portal"]');
		this.cards = this.el.querySelector('[data-ref="questionnaireResult__cards"]');
		this.cardTemplate = this.el.querySelector('[data-ref="questionnaireResult__cardTemplate"]');
		this.state = '';

		this.init();
	}

	init() {
		// Build the Handlebars template
		this.compiledCardTemplate = Handlebars.compile(this.cardTemplate.innerHTML);

		this.subscribe('Questionnaire.getResults', (payload) => {
			this.log('Questionnaire.getResults', payload);
			this.loadData(payload);
		});

		this.subscribe('Questionnaire.hideResults', () => {
			this.log('Questionnaire.hideResults');
			this.hidePortal();
		});
	}

	loadData(payload) {
		this.setState('loading');

		let elapsed = false;
		let loaded = false;

		setTimeout(() => {
			elapsed = true;
			if (loaded) {
				this.publish('Questionnaire.hasLoaded');
			}
		}, 1000);

		fetch(this.endpoint, {
			method: 'POST',
			mode: 'cors',
			cache: 'no-cache',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(payload)
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error('Network response was not OK');
				}
				return response.json();
			})
			.then((data) => {
				loaded = true;
				this.addCards(data, true);
				initBehaviors({ context: this.cards });
				this.setState('loaded');
				if (elapsed) {
					this.publish('Questionnaire.hasLoaded');
				}
			})
			.catch((error) => {
				console.error('There has been a problem with the fetch operation:', error);
			});
	}

	addCards(data, empty = false) {
		const htmlString = this.compiledCardTemplate(data);

		if (empty) {
			this.cards.replaceChildren();
		}

		const htmlFragment = document.createRange().createContextualFragment(htmlString);
		this.cards.appendChild(htmlFragment);
	}

	setState(state) {
		this.state = state;

		if (state === 'loading') {
			this.el.classList.remove('has-loaded');
			this.el.classList.add('is-loading');
		}

		if (state === 'loaded') {
			this.el.classList.remove('is-loading');
			this.el.classList.add('has-loaded');
			this.revealPortal();
		}
	}

	/**
	 * https://ccscoder.medium.com/chaining-css-animations-using-javascript-1b171708360e
	 */
	async revealPortal() {
		await this.animate(this.portal, 'heightIn', 'is-open');
		await this.animate(this.portal, 'fadeIn', 'is-visible');
		this.setState('open');
	}

	async hidePortal() {
		if (this.state === 'open') {
			await this.animate(this.portal, 'fadeOut', 'is-visible', true);
			await this.animate(this.portal, 'heightOut', 'is-open', true);
		}
		this.setState('closed');
	}

	animate(elem, animationClass, stateClass, removeStateClass = false) {
		return new Promise((resolve) => {
			// Animation end handler
			const handleAnimationEnd = () => {
				this.log('animation ended...', elem, animationClass, stateClass);
				elem.classList.remove(animationClass);
				if (removeStateClass) {
					elem.classList.remove(stateClass);
				} else {
					elem.classList.add(stateClass);
				}
				resolve(elem);
			};
			elem.addEventListener('animationend', handleAnimationEnd, { once: true });
			elem.classList.add(animationClass);
		});
	}
}

export default QuestionnaireResult;
